import {
  ContractOrderOutputDto,
  FatturaEmessaPagedDto,
  FatturaEmessaSearchDto,
  FatturaRicevutaDto,
  FatturaRicevutaPagedDto,
  FatturaRicevutaSearchDto,
  ProjectLightInfoDto,
} from '@api/client';
import { createReducer } from '@reduxjs/toolkit';
import {
  getFattureEmesse,
  getFattureRicevute,
  getFattureRicevuteExternalCollaborators,
  getOrdiniAttivi,
  getProjectsForActiveBills,
  getProjectsForPassiveBills,
  saveFattureEmesseFiltersUsed,
  saveFattureRicevuteFiltersUsed,
  saveFiltersPassiveAssociableInvoicesUsed,
} from './actions';

interface InitialState {
  fattureEmesse: FatturaEmessaPagedDto | undefined;
  fattureRicevute: FatturaRicevutaPagedDto | undefined;
  filtersEmesse: any;
  filtersEmesseUsed: FatturaEmessaSearchDto | undefined;
  filtersRicevute: any;
  filtersRicevuteUsed: FatturaRicevutaSearchDto | undefined;
  filtersPassiveAssociableInvoicesUsed: FatturaEmessaSearchDto | undefined;
  fattureRicevuteAssociable: FatturaRicevutaDto[];
  fattureRicevuteAssociated: FatturaRicevutaDto[];
  activeOrders: ContractOrderOutputDto[];
  projectsForActiveBills: ProjectLightInfoDto[];
  projectsForPassiveBills: ProjectLightInfoDto[];
  fattureRicevuteAssociablePaging: {
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
  };
}

const initialState: InitialState = {
  fattureEmesse: undefined,
  fattureRicevute: undefined,
  filtersEmesse: undefined,
  filtersEmesseUsed: undefined,
  filtersRicevute: undefined,
  filtersRicevuteUsed: undefined,
  filtersPassiveAssociableInvoicesUsed: undefined,
  fattureRicevuteAssociable: [],
  fattureRicevuteAssociated: [],
  activeOrders: [],
  projectsForActiveBills: [],
  projectsForPassiveBills: [],
  fattureRicevuteAssociablePaging: {
    page: 0,
    size: 0,
    totalElements: 0,
    totalPages: 0,
  },
};

export const fattureReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getFattureEmesse.fulfilled, (state, action) => {
      state.fattureEmesse = action.payload;
    })
    .addCase(getFattureRicevute.fulfilled, (state, action) => {
      const type = action.meta.arg.type;
      switch (type) {
        case 'billsPage':
          state.fattureRicevute = action.payload;
          break;
        case 'associated':
          state.fattureRicevuteAssociated = action.payload?.content || [];
          break;
        case 'associable':
          state.fattureRicevuteAssociable = action.payload?.content || [];
          state.fattureRicevuteAssociablePaging = {
            page: action.payload?.page || 0,
            size: action.payload?.size || 0,
            totalElements: action.payload?.totalElements || 0,
            totalPages: action.payload?.totalPages || 0,
          };
          break;
      }
    })
    .addCase(getFattureRicevuteExternalCollaborators.fulfilled, (state, action) => {
      state.fattureRicevuteAssociated = action.payload?.content || [];
    })
    .addCase(getOrdiniAttivi.fulfilled, (state, action) => {
      state.activeOrders = action.payload?.contractOrderOutputDtoList || [];
    })
    .addCase(getProjectsForActiveBills.fulfilled, (state, action) => {
      state.projectsForActiveBills = action.payload || [];
    })
    .addCase(getProjectsForPassiveBills.fulfilled, (state, action) => {
      state.projectsForPassiveBills = action.payload || [];
    })
    .addCase(saveFattureEmesseFiltersUsed, (state, action) => {
      state.filtersEmesseUsed = action.payload;
    })
    .addCase(saveFattureRicevuteFiltersUsed, (state, action) => {
      state.filtersRicevuteUsed = action.payload;
    })
    .addCase(saveFiltersPassiveAssociableInvoicesUsed, (state, action) => {
      state.filtersPassiveAssociableInvoicesUsed = action.payload;
    });
});
